import SectionContent from "./SectionContent";
import { usePageContext } from "@providers/PageProvider";
import { discoverPage } from "@utils/helper";
import _ from "lodash";
const View = () => {
  const { pageData } = usePageContext();
  const data = discoverPage.formatThroughTheLens(pageData);
  return (
    <SectionContent
      className
      type="left"
      content={_.get(data, "content")}
      title={_.get(data, "title")}
      image={_.get(data, "image")}
    />
  );
};
export default View;
